import React, { useState } from "react"
import { Link } from "react-router-dom"
import { useNavigateToPost } from "../../hooks/useNavigateToPost"
import { SmartDateFormat } from "../../util/dates"
import { PlayCircle, PlusCircle } from "react-bootstrap-icons"
import CommentSectionPreview from "../comments/CommentSectionPreview"
import { useDispatch } from "react-redux"
import { prependAndPlay } from "../../stores/mediaPlayerSlice"
import { openSongActions } from "../../stores/songActionsSlice"
import { PostListItemStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { AnchorButton, ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import { TextAsImage } from "./TextAsImage"

const ICON_SIZE = "1.6rem"
const MARGIN_SPACING = "0rem 0.5rem 0rem 0"

export const StandAloneSongListItem = ({ song, updateStatus, adminMode = false }) => {
  const [postStatus, setPostStatus] = useState(song.status)
  const navigateToPostScreen = useNavigateToPost(song.nada_path, {
    albumPath: song.album_path,
    songId: song.id,
  })

  const dispatch = useDispatch()

  const onPlayClick = (e) => {
    dispatch(prependAndPlay(mappedSong()))
  }

  const onAddClick = (e) => {
    dispatch(openSongActions(mappedSong()[0]))
  }

  const mappedSong = () => {
    return [song].map((song) => ({
      ...song,
      album_name: song.title,
      cover_image_small: song.external_photo_src,
    }))
  }

  return (
    <div className="grid grid-cols-12">
      {song.external_photo_src ? (
        <div className={PostListItemStyles.contentDiv}>
          <img
            src={song.external_photo_src}
            alt={song.title}
            className="w-full cursor-pointer"
            onClick={navigateToPostScreen}
          />
        </div>
      ) : (
        <TextAsImage
          text={song.title}
          onClick={navigateToPostScreen}
          className="cursor-pointer"
        />
      )}
      <div className={PostListItemStyles.metaDiv}>
        <PremiereHeader post={song} size="small" />
        <div className="flex">
          <div className="flex flex-none">
            <PlayCircle
              className="cursor-pointer"
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={onPlayClick}
            />
            <PlusCircle
              className="cursor-pointer"
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={onAddClick}
            />
          </div>

          <div className="flex items-start justify-between flex-grow">
            <h2
              className={clsx(
                PostListItemStyles.header,
                "inline mr-2 cursor-pointer",
                song.is_bn_premiere && styles.premiereTitle,
              )}
              dangerouslySetInnerHTML={{ __html: song.title }}
              onClick={navigateToPostScreen}
            ></h2>
            <ShareUrlButton nadaUrl={song.nada_url} renderMode="icon" />
          </div>
        </div>
        <h3>
          <Link className={PostListItemStyles.bandName} to={song.local_path}>
            {song.band_name}
          </Link>
        </h3>
        <div className="text-xs">
          {!song.is_released ? (
            <div>
              Announced&nbsp;
              {SmartDateFormat({
                dateStr: song.announced_at,
                includeTime: false,
              })}
              &nbsp;for Release on&nbsp;
              {SmartDateFormat({
                dateStr: song.published_at,
                includeTime: false,
              })}
            </div>
          ) : (
            <div>
              Released&nbsp;
              {SmartDateFormat({
                dateStr: song.published_at,
                includeTime: false,
              })}
            </div>
          )}
        </div>
        <div className={PostListItemStyles.externalLink}>
          {song.class_name === "Bandcamp" ? (
            <div className="mt-1">
              <AnchorButton href={song.external_url} target="_blank">
                Buy on&nbsp;
                {song.class_name}
              </AnchorButton>
            </div>
          ) : (
            <a href={song.external_url} target="_blank" rel="noreferrer">
              view on&nbsp;
              {song.class_name}
            </a>
          )}
        </div>
        <div className="mt-2 text-black mb-2" style={{ display: "flex" }}>
          <PlayCircle
            className="cursor-pointer"
            style={{
              minWidth: ICON_SIZE,
              width: ICON_SIZE,
              height: ICON_SIZE,
              margin: MARGIN_SPACING,
            }}
            onClick={onPlayClick}
          />
          <PlusCircle
            className="cursor-pointer"
            style={{
              minWidth: ICON_SIZE,
              width: ICON_SIZE,
              height: ICON_SIZE,
              margin: MARGIN_SPACING,
            }}
            onClick={onAddClick}
          />
          <span className="font-bold">1.</span>
          &nbsp;
          <span className="text-gray-700">{song.title}</span>
        </div>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}
        <div className="mt-4">
          <RelatedPosts postId={song.id} />
        </div>
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={song.id}
            postId={song.id}
          />
        </div>
        <CommentSectionPreview
          postId={song.id}
          postPath={song.nada_url}
        />
      </div>
    </div>
  )
}
